// These are not actually exported by the lib
export var ComscoreContentType = /*#__PURE__*/ function(ComscoreContentType) {
    ComscoreContentType["LongFormOnDemand"] = "12";
    ComscoreContentType["ShortFormOnDemand"] = "11";
    ComscoreContentType["Live"] = "13";
    ComscoreContentType["UserGeneratedLongFormOnDemand"] = "22";
    ComscoreContentType["UserGeneratedShortFormOnDemand"] = "21";
    ComscoreContentType["UserGeneratedLive"] = "23";
    ComscoreContentType["Bumper"] = "99";
    ComscoreContentType["Other"] = "00";
    return ComscoreContentType;
}({});
export var ComscoreAdType = /*#__PURE__*/ function(ComscoreAdType) {
    ComscoreAdType["LinearOnDemandPreRoll"] = "11";
    ComscoreAdType["LinearOnDemandMidRoll"] = "12";
    ComscoreAdType["LinearOnDemandPostRoll"] = "13";
    ComscoreAdType["LinearLive"] = "21";
    ComscoreAdType["BrandedOnDemandPreRoll"] = "31";
    ComscoreAdType["BrandedOnDemandMidRoll"] = "32";
    ComscoreAdType["BrandedOnDemandPostRoll"] = "33";
    ComscoreAdType["BrandedOnDemandContent"] = "34";
    ComscoreAdType["BrandedOnDemandLive"] = "35";
    ComscoreAdType["Other"] = "00";
    return ComscoreAdType;
}({});

//# sourceMappingURL=comscore-types.js.map